/**
 * Per-feature local API toggles.
 *
 * Each feature's constants.js reads its own REACT_APP_LOCAL_API_* variable, which
 * you set in .env.local — already covered by .gitignore, so a flipped toggle
 * cannot be committed. These used to be edited directly in the constants files,
 * which left the flipped state one `git add` away from production.
 *
 * See .env.local.example for the full list of variables.
 *
 * Create React App inlines REACT_APP_* at build time, so editing .env.local
 * requires restarting `npm start` — the toggles do not hot-reload.
 */

// The only place in src/ that names the local API. Keeping it here means the
// per-feature constants files cannot express the dangerous state at all, so the
// .githooks/pre-commit guard still covers every one of them.
const LOCAL_API_URL = 'http://localhost:3001';

// react-scripts sets NODE_ENV=production for `npm run build` and development for
// `npm start`. Gating on it means a production bundle resolves to the real API
// even if a REACT_APP_LOCAL_API_* flag ever reaches a committed .env.* file.
const isDevBuild = process.env.NODE_ENV !== 'production';

/**
 * Whether a feature should talk to the local API.
 *
 * Pass the `process.env.REACT_APP_LOCAL_API_*` expression itself rather than a
 * variable holding it — CRA substitutes those at the call site.
 *
 * @param {string|undefined} flag
 * @returns {boolean}
 */
export const isLocalApi = (flag) => isDevBuild && flag === 'true';

/**
 * Base URL for a feature: the local API when its flag is on, otherwise the real
 * one from REACT_APP_WORK_CALENDAR_API_URL.
 *
 * @param {string|undefined} flag
 * @returns {string}
 */
export const apiUrlFor = (flag) =>
  isLocalApi(flag)
    ? LOCAL_API_URL
    : `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}`;
